export default {"src":"/_next/static/media/second.0dc21055.svg","height":378,"width":631,"blurWidth":0,"blurHeight":0};